/**
 * Downshift Scanner Constants - Regime-Aware Version
 */

// Signal Tag Constants
export const SIGNAL_TAGS = {
  // Distribution signals (HIGH regime)
  DIST: 'DIST',
  FAILED_BO: 'FAILED_BO',
  UPTHRUST: 'UPTHRUST',
  CHURN: 'CHURN',
  
  // Volume signals
  DOWNVOL: 'DOWNVOL',
  
  // Weekly signals
  W1_WEAK: 'W1_WEAK',
  W1_DIST: 'W1_DIST',
  W1_CHURN: 'W1_CHURN',
  
  // Sector signals
  SECTOR_RS_WEAK: 'SECTOR_RS_WEAK',
  
  // Divergence signals
  OBV_DIV: 'OBV_DIV',
  AD_DIV: 'AD_DIV',
  
  // Accumulation signals (LOW regime)
  CLIMAX: 'CLIMAX',
  CLIMAX_RECLAIM: 'CLIMAX_RECLAIM',
  ABSORPTION: 'ABSORPTION',
  SPRING: 'SPRING',
  ACCUM_VOL: 'ACCUM_VOL',
};

// Tag Colors (muted, professional palette)
export const TAG_COLORS = {
  CRITICAL: '#dc2626',    // darker red - distribution, failed breakout
  WARNING: '#ea580c',     // muted orange - upthrust, downvol, weekly weak
  INFO_PURPLE: '#7c3aed', // muted purple - sector weakness
  INFO_TEAL: '#0d9488',   // muted teal - divergence
  SUCCESS: '#16a34a',     // green - accumulation signals
  DEFAULT: '#64748b',     // gray - fallback
};

// Default scanner configuration (Regime-Aware Version)
export const DEFAULT_CONFIG = {
  // Regime thresholds (UPDATED based on backtest)
  distribution_threshold: 40, // Score >= 40 (was 30) - stricter for better accuracy
  accumulation_threshold: 45, // Score >= 45 (was 30) - stricter for better accuracy
  
  // Liquidity filters
  min_avg_value_20: 10e9,  // 10 billion VND (default)
  min_price: 5000,         // 5k VND
  
  // Analysis options
  use_obv_divergence: true,
  require_weekly_confirmation: false,
  
  // Result limit
  limit: 50,
};
